import classNames from 'classnames'
import * as styles from './project-chip.css.ts'

export type ProjectChipProps = {
  name: string
  className?: string
}

/** Names the project a repository belongs to, wherever a repository is listed. */
export const ProjectChip: React.FC<ProjectChipProps> = ({ name, className }) => (
  <span className={classNames(styles.chip, className)} title={name}>
    {name}
  </span>
)
